import { render, staticRenderFns } from "./ContentUnavailableMask.vue?vue&type=template&id=06985ce8&scoped=true&"
import script from "./ContentUnavailableMask.vue?vue&type=script&lang=js&"
export * from "./ContentUnavailableMask.vue?vue&type=script&lang=js&"
import style0 from "./ContentUnavailableMask.vue?vue&type=style&index=0&id=06985ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06985ce8",
  null
  
)

export default component.exports